import { defineComponent as _defineComponent } from 'vue'
import {ref} from "vue";
  import {t} from "@/mixin/mixins";
  import ModalDialog from "@/components/ModalDialog.vue";
  import InvCreateDialogInv from "./InvCreateDialogInv.vue";
  import {computed, reactive, toRefs} from "vue";
  import Order from "@/model/Order";
  import Customer from "@/model/Customer";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'InvCreateDialog',
  props: {
    isVisible: {
      type: Boolean,
      default: () => false
    },
    clickedDay: {
      type: String,
      default: () => ""
    },
    clickedOrder: {
      type: Order,
      default: () => undefined
    },
    customer: {
      type: Customer,
      default: () => undefined
    },
    positions: {
      type: Number,
      default: () => 0
    }
  },
  emits: ["close", "saveInv"],
  setup(__props, { emit }) {

const props = __props

  const invDialog  = ref(null);
  const noteDialog  = ref(null);

  

  const isVisible = computed({
    get: () => props.isVisible,
    set: (value) => {}
  });

  

  const initialState = {
    activeTab: 0
  };

  const state = reactive({...initialState});

  toRefs(state);

  const save = () => {
    if (state.activeTab === 0) {
      if (invDialog.value) {
        //@ts-ignore
        invDialog.value.save();
      }
    } else if (state.activeTab === 1) {
      if (noteDialog.value) {
        //@ts-ignore
        noteDialog.value.save();
      }
    }
  };

  const close = () => {
    emit("close");
  };
  const saveInv = (orderResponse: Order, oldData: Order) => {
    emit("saveInv", orderResponse, oldData);
  };

return { __sfc: true,invDialog, noteDialog, props, isVisible, emit, initialState, state, save, close, saveInv, t, ModalDialog, InvCreateDialogInv }
}

})